const RESOURCE_NAME = '/objects-audit';

export default axios => ({
    getAll(params){
        return axios.get(`${RESOURCE_NAME}`, {params});
    }
});